import React, {FC, ReactElement, useEffect, useState} from "react";
import {Button, Grid,} from "@mui/material";
import {Trans, Translation} from "react-i18next";
import LoaderWithCompanySelected from "../../components/LoaderWithCompanySelected";
import {templateApi} from "../../backend/TemplateApi";
import {uiStateStore} from "../../store/UiState";
import DriveFile from "../../model/file/DriveFile";
import MyMaterialTable from "../../components/mtable/MyMaterialTable";
import Icon from "@mui/material/Icon";
import {Link} from 'react-router-dom';
import PreviewIcon from "@mui/icons-material/Preview";
import {routes} from "../../main/Routes";

interface IProps {

}

export const ClientDocsTemplate: FC<IProps> = (): ReactElement => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const language = uiStateStore.language;

    const [files, setFiles] = useState<DriveFile[]>([]);

    useEffect(() => {
        setLoading(true);
        templateApi.getClientDocsTemplates(language)
                .then(data => {
                    setFiles(data)
                    setLoading(false)
                })
                .catch(setError)
    }, [language]);

    return <>
        <LoaderWithCompanySelected loading={false} error={error}>
            <Translation>
                {t =>
                        <MyMaterialTable
                                title={t("client_docs_templates.header", "Document templates")}
                                columns={[
                                    {
                                        field: "name",
                                        render: (row: DriveFile) =>
                                                <Grid container spacing={1} alignItems="center" justifyContent="flex-start">
                                                    <Grid item>
                                                        <Icon>
                                                            <img alt={row.name} src={row.iconLink} height={16} width={16}/>
                                                        </Icon>
                                                    </Grid>
                                                    <Grid item>{row.name}</Grid>
                                                </Grid>
                                    },
                                ]}
                                isLoading={loading}
                                data={files}
                                options={{
                                    search: true,
                                    header: false,
                                    sorting: true,
                                    paging: false,
                                    draggable: false,
                                    actionsColumnIndex: 1000,
                                }}
                                actions={[
                                    (row: DriveFile) => ({
                                        icon: () => <Button component={Link}
                                                            to={routes.clientDocsTemplatesOpen.replace(":templateId", row.id)}
                                                            target="_blank" rel="noopener noreferrer"
                                                            variant="contained" color="primary" startIcon={<PreviewIcon/>}>
                                            <Trans i18nKey="common.preview">Preview</Trans>
                                        </Button>,
                                        onClick: () => {
                                        }
                                    }),
                                ]}
                        />
                }
            </Translation>
        </LoaderWithCompanySelected>
    </>
};